import { Actions } from './grid-actions.enum';

export class GridAction<T = any> {
  constructor(public action: Actions, public value?: T) {}
}
